<template>
  <v-container fluid grid-list-lg fill-height>
    <v-layout row wrap>
      <v-flex xs12 md4 lg3 xl2>
        <v-card style="overflow: scroll; height: 100%">
          <v-system-bar color="accent" dark window>
            <v-toolbar-title>Разделы</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small icon @click="openForm(null)" v-if="accesses['helper-elements_create']" class="mx-0"><v-icon class="mx-0">add</v-icon></v-btn>
          </v-system-bar>
            <dantser-tree
              class="pa-2"
              dnd
              ref="helperTree"
              :selectMode="1"
              :source="helperTree"
              @click-node="getHelpContent"
              @drop-node="changePosition"
              @ctx-menu="openCtxMenu($event)"
            ></dantser-tree>
        </v-card>
      </v-flex>
      
      <v-flex xs12 md8 lg9 xl10 style="overflow: scroll">
        <helper-form v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></helper-form>
        <v-card v-else style="height: 100%; overflow: auto; position: relative">
          <v-system-bar color="accent" dark window style="position: sticky; top: 0;">
            <v-toolbar-title>Определение</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field class="my-0" style="margin-right: -8px" flat solo-inverted single-line label="Поиск" v-model="search" hide-details
              append-icon="search" @click:append="searchHelp" @keyup.enter="searchHelp"></v-text-field>
          </v-system-bar>
          <template v-if="helperElement">
            <div class="text-xs-left mt-2 pl-3 headline">
              <span>{{helperElement.name}}</span>
            </div>
            <div class="pa-3">
              <div v-for="(block, index) in helperElement.contents">
                <video v-if="block.type===1" controls style="max-width: 100%; width: 500px;">
                  <source :src="block.data">
                  Ваш браузер не поддерживает видеоплеер
                </video>
                <p v-else v-html="block.data"></p>
              </div>
            </div>
          </template>
          <template v-if="searchResults.length>0">
            <v-flex xs12 class="pa-3">
              <div id="help-search-list">
                <h3 class="title mb-2 pl-2"><i>Результаты, найденные по запросу</i> : "{{searchText}}"</h3>
                <ol class="ml-4">
                  <li v-for="result in searchResults" :key="result.id">
                    <a class="dashed blue-grey--text" @click="scrollTo(result.id)">{{result.name}}</a>
                  </li>
                </ol>
              </div>
              <div v-for="result in searchResults" :key="result.id" :id="result.id">
                <div class="text-xs-left mt-2 pl-3 headline">
                  <span>{{result.name}}</span>
                </div>
                <div class="pa-3">
                  <div v-for="(block, index) in result.contents">
                    <video v-if="block.type===1" controls style="max-width: 100%; width: 500px;">
                      <source :src="block.data">
                      Ваш браузер не поддерживает видеоплеер
                    </video>
                    <div v-else v-html="block.data"></div>
                  </div>
                </div>
              </div>
            </v-flex>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
    
    <context-menu id="helper-context-menu" ref="ctxMenu">
      <li @click="openForm(currentElement)" v-if="accesses['helper-elements_update']"><v-icon small>mdi-pencil</v-icon> Редактировать</li>
      <li @click="deleteHelper(currentElement)" v-if="accesses['helper-elements_delete']"><v-icon small>mdi-delete</v-icon> Удалить</li>
    </context-menu>
    
  </v-container>
</template>

<script>
  import HelperForm from './Forms/HelperForm'
  import contextMenu from 'vue-context-menu'
  import {mapGetters} from 'vuex'
  
  export default {
    name : 'Helper',
    
    components:{
      HelperForm,
      contextMenu
    },
    
    computed:{
      ...mapGetters('helper', ['helperTree']),
      accesses() {
        return this.$store.state.app.account.accesses['helper'] || {}
      },
    },
    
    data() {
      return {
        search: '',
        searchText: '',
        dialog: false,
        formProps: {},
        helperElement: null,
        currentElement: null,
        searchResults: []
      }
    },
    
    created(){
      this.$store.dispatch('helper/getHelperTree', 'all')
    },
    
    mounted(){
      if(this.$route.query.id){
        this.displayHelper(this.$route.query.id)
        this.$refs.helperTree.setSelected(this.$route.query.id)
      }
    },
    
    methods : {
      getHelpContent(node){
        let query = {...this.$route.query, id: node.id}
        this.$router.replace({query: query})
        this.searchResults = []
        this.displayHelper(node.id)
      },
      
      displayHelper(id){
        this.$store.dispatch('helper/getHelpContent', id).then( data => {
          this.helperElement = data
          this.dialog = false
        })
      },
  
      openCtxMenu(eventData){
        if(this.accesses['helper-elements_delete'] || this.accesses['helper-elements_update']){
          this.$refs.ctxMenu.open()
          this.currentElement = eventData.data
        }
      },
  
      deleteHelper(data){
        this.$root.$confirm('Удаление раздела', 'Вы уверены, что хотите удалить данный раздел? Вложенные разделы также будут удалены.', {}).then( confirm => {
          this.$store.dispatch('helper/deleteHelpContent', data.id).then( response => {
            this.$refs.helperTree.deleteNodeById(data.id)
            this.$store.commit('helper/setHelperTree', this.helperTree)
          })
        }).catch(()=>{})
      },
  
      openForm(data){
        if(data!==null){
          this.$store.dispatch('helper/getHelpContent', data.id).then( element => {
            this.formProps = { editMode: true, data: element }
            this.dialog = true
          })
        } else {
          this.formProps = { editMode: false }
          this.dialog = true
        }
      },
  
      searchHelp(){
        if(this.search.length === 0){
          this.searchResults = []
        } else {
          this.$store.dispatch('helper/searchHelpContent', this.search).then( data => {
            this.searchResults = data
            this.searchText = this.search
          })
        }
        this.helperElement = null
      },
  
      scrollTo(id){
        let element = document.getElementById(id)
        if(element){
          element.scrollIntoView({block: "start", behavior: "smooth"})
        }
      },
  
      changePosition(eventData){
        eventData.element = 'helper'
        this.$store.dispatch('helper/changePosition', eventData)
      },
  
      saveChanges(eventData){
        if(eventData.editMode){
          let node = this.$refs.helperTree.getNodeById(eventData.data.id)
          node = Object.assign(node, eventData.data)
        } else {
          if(eventData.data.parent_id){
            let node = this.$refs.helperTree.getNodeById(eventData.data.parent_id)
            node.children.push(eventData.data)
            node.expanded = true
          } else {
            this.helperTree.push(eventData.data)
          }
        }
        this.$store.commit('helper/setHelperTree', this.helperTree)
        this.dialog = false
      }
    }
  }
</script>

<style scoped>
  #helper-context-menu ul.ctx-menu li{
    padding: 5px 7px 5px 10px;
    cursor: pointer;
    font-size: 1rem;
  }
  #helper-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #helper-context-menu ul.ctx-menu li i{
    width: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/apps/help/components/Helper/Helper.vue